function initReviewSlider(){

	$(".review-slider").each(function () {
		var slider = $(this).slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			prevArrow: slickPrevArrowCodeV2,
			nextArrow: slickNextArrowCodeV2,
			adaptiveHeight: true
		});		

		slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
			initReviewButtonHandling();
		});
	});
}

function updateReviews(){
	//equalize reviews height
	var $rw = $("main").find("#tx-google-reviews, .reviews__content");
	if($rw.length > 0){
		$rw.each(function(){
			var th = 0;
			$(this).find(".reviews__item").each(function(){
				var $txt = $(this).children(".reviews__card");
				updateReviewTextLength($txt);
				$txt.css("height", "auto");
				if($txt.outerHeight() > th){
					th = $txt.outerHeight();
				}
			});
			
			if(th > 0){
				$(this).find(".reviews__item").each(function(){
					$(this).children(".reviews__card").css("height", th + "px");
				});
			}
		});
	}

	$(".review-slider").each(function () {
		$(this).slick('refresh');
	});
	
	//star width
	updateReviewStarWidth();
}

function updateReviewStarWidth(){
	var $sgr = $(".simple-google-reviews");
	if($sgr.length > 0){
		$sgr.each(function(){
			//console.log("updateReviewStarWidth()...")
			var $gr = $(this).find(".general-rating");
			if($gr.length > 0){
				//console.log("$gr.html():" + $gr.html());
				var rating = parseFloat($gr.attr("data-rating").replace(",", "."));
				//console.log("updateReviewStarWidth() # rating:" + rating);
				var ratingFloored = Math.floor(rating);
				//console.log("updateReviewStarWidth() # ratingFloored:" + ratingFloored);
				var $starsContainer = $gr.siblings(".star-rating-stars").children(".stars");
				var $lastStar = $starsContainer.children("span").eq(ratingFloored);
				if($lastStar.length > 0){
					var starWidth = (rating-ratingFloored)*20;
					//console.log("updateReviewStarWidth() # starWidth:" + starWidth);
					$lastStar.find(".stars-fill").css("width", starWidth);
					$lastStar.nextAll("span").hide();
				}
			}
		});
	}
}
		
function updateReviewTextLength($tc){

	if(!$tc.hasClass("initialized")){
		var $text = $tc.find(".reviews__text");
		
		
		if($text){
			const textHeight = $text.height();
			const lineHeight = $text.css("line-height").replace('px', '');
			const lines = textHeight / lineHeight;
			
			if(lines > 3){
				
				$text.closest(".reviews__card").addClass("clamped");
				
				var showMore = $text.attr("data-show-more");
				var $plusBtn = $("<button><span>"+showMore+"</span></button>");
				$plusBtn.addClass("reviews__more");
				$text.after($plusBtn);

				var showLess = $text.attr("data-show-less");
				var $minusBtn = $("<button><span>"+showLess+"</span></button>");
				$minusBtn.addClass("reviews__less");
				$text.after($minusBtn);	
			}
		}

		initReviewButtonHandling();

		$tc.addClass("initialized");
	}
}

function initReviewButtonHandling(){

	$(".reviews__more").on("keydown", handleKeyDownForClick);
	$(".reviews__less").on("keydown", handleKeyDownForClick);
	$(".reviews__more").on("click",function(){
		$(this).closest(".reviews__card").removeClass("clamped");
		$(this).closest(".reviews__card").removeClass("full");
		$(this).closest(".reviews__card").addClass("full");					
		updateReviews();
	});
	$(".reviews__less").on("click",function(){
		$(this).closest(".reviews__card").removeClass("full");
		$(this).closest(".reviews__card").addClass("clamped");
		updateReviews();
	});
}